const teamData = {
	teamSection: {
		title: "Meet Our Team",
		description:
			"Our dedicated team of professionals combines creative expertise with deep analytical skills to deliver results-driven video marketing strategies.",
		members: [
			{
				name: "Shashi Shekhar Pandey",
				role: "Founder & CEO",
				image: "/about/shekhar.png",
				description:
					"With over half a decade of digital marketing experience, Shekhar drives our vision and innovation.",
			},
			{
				name: "Suraj Mandal",
				role: "Founder & CTO",
				image: "/about/suraj.png",
				description:
					"Years of diverse experience in software development and various other fields like building automation and ai tooling.",
			},
			{
				name: "Paragshree Behera",
				role: "Founder & Aviation Expert",
				image: "/about/paragshree.png",
				description:
					"Founder and investor with aviation expertise, Paragshree drives TheHighraysYT Digital's growth with strategic financial leadership.",
			},
			{
				name: "Mani Pratap Singh Yadav",
				role: "COO & Digital Marketing Expert",
				image: "/about/mani.png",
				description:
					"Mani Pratap is a digital marketing expert with a passion for aviation and a commitment to excellence.",
			},
			{
				name: "Vinit Suthar",
				role: "Video Producer & Editor",
				image: "/about/vinit.png",
				description:
					"With over 5 years of experience, Vinit is a creative force in video production.",
			},
		],
	},
};

import { domAnimation, LazyMotion, m } from "framer-motion";
import Image from "next/image";

export default function OurTeam() {
	return (
		<LazyMotion features={domAnimation}>
			<section className="py-24 bg-white relative overflow-hidden">
				{/* Background decoration */}
				<div className="absolute top-0 right-0 w-1/3 h-full bg-linear-to-b from-zinc-50 to-transparent -z-10" />

				<div className="container mx-auto px-4">
					<m.div
						initial={{ opacity: 0, y: 20 }}
						whileInView={{ opacity: 1, y: 0 }}
						viewport={{ once: true }}
						className="max-w-3xl mb-16"
					>
						<h2 className="font-syne text-4xl md:text-5xl font-bold uppercase tracking-tight text-zinc-900 mb-6">
							Meet Our <span className="text-primary">Team</span>
						</h2>
						<p className="font-inter text-lg text-zinc-600">
							{teamData.teamSection.description}
						</p>
					</m.div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
						{teamData.teamSection.members.map((member, index) => (
							<m.div
								key={member.name}
								initial={{ opacity: 0, y: 30 }}
								whileInView={{ opacity: 1, y: 0 }}
								viewport={{ once: true }}
								transition={{ delay: index * 0.1, duration: 0.5 }}
								className="group relative bg-white rounded-[1.325rem] border border-zinc-200 p-2 hover:border-zinc-300 hover:shadow-xl transition-[border-color,box-shadow] duration-300"
							>
								<div className="aspect-[4/3] w-full overflow-hidden rounded-2xl bg-zinc-100 mb-6 relative">
									<Image
										src={member.image}
										alt={member.name}
										width={400}
										height={300}
										className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
										loading="lazy"
										sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
									/>
									{/* Overlay gradient */}
									<div className="absolute inset-0 bg-linear-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
								</div>

								<div className="px-4 pb-6">
									<h3 className="font-syne text-xl font-bold uppercase tracking-tight text-zinc-900 mb-1">
										{member.name}
									</h3>
									<p className="font-inter text-sm font-semibold text-primary uppercase tracking-wider mb-4">
										{member.role}
									</p>
									<p className="font-inter text-sm text-zinc-600 leading-relaxed">
										{member.description}
									</p>
								</div>
							</m.div>
						))}
					</div>
				</div>
			</section>
		</LazyMotion>
	);
}
